import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Tab, TabBar } from 'atoms/navigation/TabBar';
import { SEARCH_PARAMS } from 'components/search/InstantSearch/types';
import { buildFilterQuery } from 'components/search/InstantSearch/utils';
import { useSettlableWalletsSearch } from 'hooks/useSettlableWalletsSearch';
import { glossary, navLabels } from 'lib/glossary';

type Props = {
  tabs: Record<LeaguePageTabs, string>;
};

export enum LeaguePageTabs {
  OVERVIEW = 'OVERVIEW',
  FIXTURES = 'FIXTURES',
  CARDS = 'CARDS',
}

const tabsTitle: Record<LeaguePageTabs, MessageDescriptor> = {
  [LeaguePageTabs.OVERVIEW]: navLabels.overview,
  [LeaguePageTabs.FIXTURES]: navLabels.fixtures,
  [LeaguePageTabs.CARDS]: glossary.cards,
};

export const Tabs = ({ tabs }: Props) => {
  const defaultSettlementWallets = useSettlableWalletsSearch();
  return (
    <FullWidthContainer.NoPadding>
      <TabBar variant="flat" fullWidth>
        {Object.values(LeaguePageTabs).map(tab => (
          <Tab
            key={tab}
            to={
              tab === LeaguePageTabs.CARDS
                ? `${tabs[tab]}?${buildFilterQuery({
                    [SEARCH_PARAMS.ON_SALE]: true,
                    ...(defaultSettlementWallets
                      ? {
                          [SEARCH_PARAMS.PURCHASE_OPTIONS]:
                            defaultSettlementWallets,
                        }
                      : {}),
                  })}`
                : tabs[tab]
            }
          >
            <FormattedMessage {...tabsTitle[tab]} />
          </Tab>
        ))}
      </TabBar>
    </FullWidthContainer.NoPadding>
  );
};
